

interface IrbGpt {
  messageHtml: string,
  inputMessage: string, 
}

import { defineComponent, ref, PropType, computed, onMounted  } from "vue";
import moment from "moment";
import { Field } from "vee-validate";
import { useStore} from "vuex";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { useRoute } from "vue-router";


export default defineComponent({
  name: "table-action",
  components: {
    
  },
  methods: {
    
  },
  props: {
    initialMessages: Array as PropType<Array<string>>
  },
  
  setup() { 
    const store = useStore();
    const route = useRoute();

    const data = ref<IrbGpt>({
      messageHtml: "",
      inputMessage: "",
    });

    store.commit(Mutations.SET_IRB_GPT_INFO, {});
    
    onMounted(() => {
      /*store.dispatch(tableCallAFunction != null? tableCallAFunction: "", {
        params: {
            Page: paging.value.page,
            RecordsPerPage: recordsPerPage.value,
            title: titleSearchRetuls?.value,
          },
        });*/
    });

    
    const irbGptMessage = computed(() => {
      let rta = data.value.messageHtml;
      if (store.getters.currentGptInfo.data?.result?.length > 0) {
        //rta +=  "<p>" + store.getters.currentGptInfo.data?.result[0].irbGptMessageResponse;
      }
      return rta;
    });


    

    const submit = () => {
      data.value.messageHtml = data.value.messageHtml + "<p>" + data.value.inputMessage + "<p>";
      store.dispatch(Actions.POST_IRB_GPT, {
          IrbId : route?.params?.id,
          Message: data?.value?.inputMessage,
      });
      data.value.inputMessage = "";
    };

    return {
      store,
      submit,
      data,
      irbGptMessage,
    };
  },
});
